/**
 * Les 7 groupes de navigation de la bible §5.2 (écart E4 résorbé le 2026-07-29).
 * La sidebar est DÉRIVÉE du registre de modules : chaque ModuleDef déclare son
 * navGroup parmi ces valeurs — aucune liste codée en dur dans le noyau.
 */
export const NAV_GROUPS = [
  "pilotage", // Tableau de bord, À relancer, Mes tâches
  "relations", // Cabinets, Praticiens, Prospects
  "communications", // E-mails, Appels, WhatsApp
  "operations", // Travaux/retours, Courses, Kanban, GÉCÉRAM FLOW
  "finance", // Suivi financier, Vevidental, Pennylane
  "ressources", // Bibliothèque GéCéram
  "administration", // Utilisateurs, intégrations, audit, paramètres
] as const;

export type NavGroupId = (typeof NAV_GROUPS)[number];

export const NAV_GROUP_LABELS: Record<NavGroupId, string> = {
  pilotage: "Pilotage",
  relations: "Relations",
  communications: "Communications",
  operations: "Opérations",
  finance: "Finance",
  ressources: "Ressources",
  administration: "Administration",
};

export function isNavGroup(value: string): value is NavGroupId {
  return (NAV_GROUPS as readonly string[]).includes(value);
}
